import type { Study } from './study.interface';

export interface cv_StudyType {
    Abbreviation: string;
    C_StudyType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    ModifiedBy: string;
    SortOrder: number | null;
    Study: Study[];
    StudyType: string;
    Version: number;
}
